<div class="col-md-12 mb-30">
  <div class="card card-statistics h-100">
    <div class="card-body">
     <h5 class="card-title border-0 pb-0">فرم اطلاعات  تحویل گواهی نامه </h5>
     <br/>
     <br/>
     <div class="row">
      <div class="form-group col-md-12">
        <label for="exampleInputEmail1">توضیحات  </label>
        <input  type="text" class="form-control"  [(ngModel)]="Dsc_Form"  placeholder=" اینجا تایپ کنید ...">
      </div>
    </div>
      <div class="row">
      <div  class="form-group col-md-6" >
        <button *ngIf="!Procssing && EditRecord==0"  type="button" (click)="openModal_Certificate(templateCertificate)"  class="btn btn-info" style="margin-left: 5px;"><i class="fa  fa-plus"></i> افزودن گواهی نامه </button>
        <button *ngIf="!Procssing && EditRecord==0" type="button" (click)="OnSubmitForm()" [disabled]="DataList_Calibration.length==0" class="btn btn-success" style="margin-left: 5px;"><i class="fa  fa-plus"></i> تایید و ثبت نهایی اطلاعات </button>
        <button routerLink="/CertifivateDelivery" *ngIf="!Procssing" type="button" class="btn btn-warning"><i class="fa fa-mail-reply"></i> بازگشت </button>
        <img *ngIf="Procssing" src="assets/Loading.gif" style="width: 25px;" />
      </div>
     </div>
     <div class="table-responsive">
      <table class="mb-0 table table-bordered table-3 text-center table-striped">
        <thead style="background-color: #489b39; color: white;">
          <tr>
            <th>#</th>
            <th>کد گواهی نامه</th>
            <th>شماره رسید</th>
            <th>نام دستگاه</th>
            <th>کد دستگاه</th>
            <th>سریال دستگاه</th>
            <th *ngIf="EditRecord==0">امکانات</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of DataList_Calibration">
            <td>{{DataList_Calibration.indexOf(item)+1}}</td>
            <td>{{item.expiration_title}}</td>
            <td>{{item.dsc}}</td>
            <td>{{item.device_name}}</td>
            <td>{{item.device_code}} </td>
            <td>{{item.device_serial}} </td>
            <td  *ngIf="EditRecord==0" style="cursor: pointer;">
              <div class="btn-group  " role="group" aria-label="دکمه group with nested dropdown">
                <div class="btn-group" role="group">
                    <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        امکانات
                    </button>
                    <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                      <a style="cursor: pointer;" (click)="DataList_Calibration_Remove(DataList_Calibration.indexOf(item))" class="dropdown-item" ><i class="fa fa-remove"></i> حذف </a>
                    </div>
                </div>
              </div>

            </td>

          </tr>
        </tbody>
      </table>
  </div>
    </div>

  </div>
</div>


<ng-template #templateCertificate>
  <div class="modal-header">
     <h4 class="modal-title pull-left">لیست اطلاعات 'گواهی نامه'  </h4>
     <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Certificate.hide()">
        <span aria-hidden="true">×</span>
     </button>
  </div>
  <div class="modal-body">
    <div class="card-body">
      <div class="row">
        <div class="form-group col-md-12">
            <label for="exampleInputEmail1">کد گواهی نامه  </label>
            <input  type="text" class="form-control" (keyup)="ReadData_Certificate_KeySearch()"  [(ngModel)]="Search_Code_Certificate_Table"  placeholder="برای جستجو اینجا تایپ کنید ...">
        </div>
      </div>
      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>کد گواهی نامه</th>
              <th>شماره رسید</th>
              <th>نام دستگاه</th>
              <th>امکانات</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of Data_Certificate_Search">
                      <td>{{Data_Certificate_Search.indexOf(item)+1}}</td>
                      <td>{{item.expiration_title}}</td>
                      <td>{{item.dsc}}</td>
                      <td>{{item.device_name}}</td>
                      <td (click)="Set_Selected_Certificate_Record(item)" style="cursor: pointer;">
                        <button class="btn btn-info"><i class="fa fa-check"></i> انتخاب</button>
                      </td>

            </tr>
          </tbody>
        </table>
    </div>
  </div>
 </div>
  <div class="modal-footer">
    <img *ngIf="Procssing_Certificate" src="assets/Loading.gif" style="width: 25px;" />
    <button  *ngIf="!Procssing_Certificate" type="button" (click)="ReadData_Certificate()"  class="btn btn-info" style="margin-left: 5px;"><i class="fa  fa-search"></i> جستجوی اطلاعات </button>
     <button type="button" class="btn btn-danger" (click)="modalRef_Certificate.hide()">بستن</button>
  </div>
</ng-template>
